<script>
export default {
    name: 'AnswerRatingStart',
    data() {
      return {
        formData: {
          overall_satisfaction: null,
        }
      }
    },
    methods: {
      onStart(value) {
        this.formData.overall_satisfaction = value;
        this.$emit('nextStep', this.formData);
      },
    },
};
</script>

<template>
  <div class="answer-rating-start">
    <p class="answer-rating-start__paragraph">
      Sind Sie mit dieser Antwort und der Beratung zufrieden?
      <span class="answer-rating-start__icon-buttons">
        <button
          class="answer-rating-start__icon-button answer-rating-start__icon-button--positive"
          v-on:click.prevent="onStart(true)"
        >
          Ja
        </button>
        <button
          class="answer-rating-start__icon-button answer-rating-start__icon-button--negative"
          v-on:click.prevent="onStart(false)"
        >
          Nein
        </button>
      </span>
    </p>
  </div>
</template>

<style lang="scss">
.answer-rating-start {
  text-align: center;
}

.answer-rating-start__paragraph {
  margin: 0;
  color: $color-secondary-alt;
  font-size: 1.8rem;
}

.answer-rating-start__icon-buttons {
  display: inline;
  vertical-align: middle;
}

.answer-rating-start__icon-button {
  border: none;
  background-color: transparent;
  padding: 0;
  width: 3.2rem;
  height: 3.2rem;
  background-position: center;
  font-size: 0;
  cursor: pointer;

  &:hover {
    background-color: rgba($color-primary, 0.1);
  }
}

.answer-rating-start__icon-button--positive {
  background-image: url('~@/assets/images/ico-thumb-up.svg');
}

.answer-rating-start__icon-button--negative {
  background-image: url('~@/assets/images/ico-thumb-down.svg');
}
</style>
